module.exports = __webpack_public_path__ + "img/qrcode_feng.71515d12.png";